import { render } from "./IntegrationRegister.vue?vue&type=template&id=6db72f32&scoped=true"
import script from "./IntegrationRegister.vue?vue&type=script&lang=js"
export * from "./IntegrationRegister.vue?vue&type=script&lang=js"

import "./IntegrationRegister.vue?vue&type=style&index=0&id=6db72f32&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6db72f32"]])

export default __exports__